/**
 * One helper write in plain English for the owner's Team → Activity list
 * (Ray 2026-10-04). The server records the raw route; the owner should
 * read "Changed the rates of Superman WiFi", not "POST /api/vendo/…".
 */
export function describeTeamActivity(
   method: string,
   path: string,
   vendoName: (id: string) => string | undefined
): string {
   const p = path.replace(/^\/api/, '');
   const dev = p.match(/^\/(?:vendo|openwrt)\/devices\/([a-f0-9]{24})(\/.*)?$/);
   const name = dev ? vendoName(dev[1]) ?? 'a vendo' : '';
   const rest = dev?.[2] ?? '';
   const on = (what: string) => `${what} on ${name}`;

   if (dev) {
      if (!rest && method === 'PATCH') return `Changed the settings of ${name}`;
      if (!rest && method === 'DELETE') return `Deleted the vendo ${name}`;
      if (rest === '/rates') return `Changed the rates of ${name}`;
      if (rest === '/ssid') return `Renamed the WiFi of ${name}`;
      if (rest === '/reboot') return `Restarted the router of ${name}`;
      if (rest.startsWith('/update-firmware')) return on('Started a router update');
      if (rest.startsWith('/whitelist')) return on('Changed an Unlimited phone');
      if (rest === '/grant-session') return on('Gave free time to a phone');
      if (rest === '/reset-stats') return `Reset the sales of ${name}`;
      if (rest.startsWith('/transfer')) return `Started a transfer of ${name}`;
      if (rest === '/move-license') return `Moved the license of ${name}`;
      if (rest.startsWith('/vlans')) return on('Changed the networks');
      if (rest.startsWith('/client-access')) return on('Changed the sub-login');
      return on('Changed a setting');
   }
   if (/^\/vendo\/sessions\/[a-f0-9]{24}\/extend$/.test(p)) return 'Added time to a customer';
   if (/^\/vendo\/sessions\/[a-f0-9]{24}\/speed$/.test(p)) return "Changed a customer's speed";
   if (/^\/vendo\/sessions\/[a-f0-9]{24}\/(pause|resume)$/.test(p)) return 'Paused or resumed a customer';
   if (/^\/vendo\/sessions\/[a-f0-9]{24}$/.test(p) && method === 'DELETE') return 'Kicked a customer';
   if (/^\/vendo\/sessions\//.test(p)) return 'Changed a customer session';
   if (/^\/vendo\/rates\//.test(p)) return 'Changed a rate';
   if (p === '/vendo/vouchers/bulk-generate') return 'Printed vouchers';
   if (/^\/vendo\/vouchers/.test(p)) return 'Deleted vouchers';
   if (p === '/vendo/whitelist') return 'Changed an Unlimited phone';
   if (/^\/vendo\/data-plans/.test(p)) return 'Changed a data plan';
   if (/^\/team/.test(p)) return 'Changed who helps on this account';
   if (/^\/store\//.test(p)) return 'Uploaded a picture or sound for the WiFi page';
   return `Changed something (${method} ${p})`;
}
